import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessageWrappedInSpan } from '../../misc';
import classNames from 'classnames';
import { useRouteMatch } from 'react-router-dom';

// material ui
import Chip from '@material-ui/core/Chip';

const ALL_PHOTOS_ID = 'allphotos';

const ExtendedSearchCategorySearchTab = (props) => {
  const { categories, eventId, startNumber, onNavigateTo } = props;

  const match = useRouteMatch();

  const selectedCategoryId = match.params.categoryId;

  const handleChipChanged = (categoryId) => {
    onNavigateTo(`/event/${eventId}/category/${categoryId}/${startNumber}`);
  };

  return (
    <div className="row center-xs">
      {categories.searchAllPhotos && (
        <Chip
          classes={{
            root: classNames('extended-search-category-chip', {
              selected: selectedCategoryId === ALL_PHOTOS_ID,
            }),
          }}
          key={ALL_PHOTOS_ID}
          label={
            <FormattedMessageWrappedInSpan
              id="extendedSearchCategorySearchTab.allPhotosChip"
              defaultMessage="All photos of the event"
            />
          }
          onClick={() => handleChipChanged(ALL_PHOTOS_ID)}
        />
      )}
      {categories.mediaCollections.map((mc) => {
        if (mc.name !== 'ALL pictures of the event') {
          return (
            <Chip
              classes={{
                root: classNames('extended-search-category-chip', {
                  selected: selectedCategoryId === mc.id,
                }),
              }}
              key={mc.id}
              label={mc.name}
              onClick={() => handleChipChanged(mc.id)}
            />
          );
        }
      })}
    </div>
  );
};

ExtendedSearchCategorySearchTab.propTypes = {
  eventId: PropTypes.number,
  startNumber: PropTypes.string,
  categories: PropTypes.object,
  onNavigateTo: PropTypes.func,
};

export { ExtendedSearchCategorySearchTab };

export default createFragmentContainer(ExtendedSearchCategorySearchTab, {
  categories: graphql`
    fragment ExtendedSearchCategorySearchTab_categories on Event {
      sgId
      mediaCollections {
        id
        name
      }
      searchAllPhotos
    }
  `,
});
